@let messages = getErrorMessages();
@if (messages.length > 0) {
  <ul [id]="id()" role="alert">
    @for (error of getErrorMessages(); track $index) {
      <li><ds-icon name="alert-circle" />{{ error }}</li>
    }
  </ul>
}
